export const overallPerformanceRating = 'Overall Performance Rating';
